import React from 'react'
import { Dialog, BasicDialogBody } from '../modal'
import { MultiSelectCombobox } from '../combobox'
import { FormattedMessage } from 'react-intl'
import { ContrastFormattedMessage } from '../../components/contrast-formatted-message'

interface Props {
  readonly title: string
  readonly isOpen: boolean
  readonly initialAvailableTags: string[]
  readonly initialSelectedTags: string[]
  readonly onCancel: () => void
  readonly onConfirm: (selectedTags: string[]) => void
}

interface State {
  readonly selectedTags?: string[]
  readonly newTags: string[]
}

export class TagDialog extends React.Component<Props, State> {
  public readonly state: State = {
    selectedTags: undefined,
    newTags: []
  }

  public render() {
    const { initialAvailableTags = [], title, isOpen } = this.props

    return (
      <ContrastFormattedMessage id="placeholder_addTags">
        {(placeholder) => (
          <Dialog
            isOpen={isOpen}
            onCancel={this.handleCancel}
            renderTitle={() => title}
            size="x-large"
          >
            <BasicDialogBody
              body={
                <MultiSelectCombobox
                  label="Add Tags"
                  renderLabel={() => undefined}
                  placeHolderText={placeholder}
                  onChange={this.handleChange}
                  values={
                    this.state.selectedTags || this.props.initialSelectedTags
                  }
                  items={[
                    {
                      name: '',
                      items: initialAvailableTags.concat(this.state.newTags)
                    }
                  ]}
                  isAddAllowed={true}
                  itemsEqual={(a, b) => a === b}
                  itemFromInput={(inputValue) => inputValue}
                  createMessage={{
                    id: 'title_createTag'
                  }}
                  onNewItemClick={this.onNewItemClick}
                />
              }
              confirmButtonText={<FormattedMessage id="action_save" />}
              cancelButtonText={<FormattedMessage id="action_cancel" />}
              onCancel={this.handleCancel}
              onConfirm={this.handleConfirm}
            />
          </Dialog>
        )}
      </ContrastFormattedMessage>
    )
  }

  private onNewItemClick = (newItem: string) => {
    if (
      !this.state.newTags.includes(newItem) &&
      !this.props.initialAvailableTags.includes(newItem)
    ) {
      this.setState((prevState) => ({
        newTags: prevState.newTags.concat(newItem)
      }))
    }
  }

  private handleConfirm = () => {
    this.props.onConfirm(
      this.state.selectedTags || this.props.initialSelectedTags
    )
    this.resetState()
  }

  private handleCancel = () => {
    this.props.onCancel()
    this.resetState()
  }

  private handleChange = (selectedTags) => {
    this.setState({ selectedTags })
  }

  private resetState = () => {
    this.setState({ selectedTags: undefined, newTags: [] })
  }
}
